// Central mapping between logical page ids (used by onNavigate throughout the
// app) and real URL paths. Keeping this in one place lets the whole app keep
// using the simple `onNavigate('over-ons')` style while the browser URL stays
// in sync for deep-linking, back/forward and sharing.

export type PageId =
  | 'home'
  | 'hypotheken'
  | 'woonboten'
  | 'verzekeringen'
  | 'over-ons'
  | 'kosten'
  | 'contact'
  | 'privacy'
  | 'klachten'

export const idToPath: Record<PageId, string> = {
  home: '/',
  hypotheken: '/hypotheken',
  woonboten: '/woonboten',
  verzekeringen: '/verzekeringen',
  'over-ons': '/over-ons',
  kosten: '/kosten',
  contact: '/contact',
  privacy: '/privacy',
  klachten: '/klachten',
}

const pathToIdMap: Record<string, PageId> = Object.entries(idToPath).reduce(
  (acc, [id, path]) => {
    acc[path] = id as PageId
    return acc
  },
  {} as Record<string, PageId>,
)

export function pathToId(pathname: string): PageId {
  // Normalise trailing slashes (except root) so /kosten/ === /kosten
  const normalized =
    pathname.length > 1 && pathname.endsWith('/')
      ? pathname.slice(0, -1)
      : pathname
  return pathToIdMap[normalized] ?? 'home'
}
